import { sendAnalyticsInfo } from 'features/analytics/helpers';
import { TerminationType } from 'features/call/call-base/enums';

export const sendMeetingEnded = (
  terminationType: TerminationType,
  interpretTime: number,
  isFaceTimeCall: boolean
) => {
  const terminationString = TerminationType[terminationType];
  const meetingLabel = isFaceTimeCall ? 'FaceTime' : 'Zoom';
  return sendAnalyticsInfo({
    Method: 'handleZoomMeetingEnded',
    LogGroup: meetingLabel,
    TerminationType: terminationString,
    InterpretTime: interpretTime,
    Message: `${meetingLabel} meeting ended with termination type ${terminationString} and interpret time ${interpretTime}`,
  });
};
